import { render, staticRenderFns } from "./KitBuilder.vue?vue&type=template&id=5bc2659a&scoped=true&"
import script from "./KitBuilder.vue?vue&type=script&lang=ts&"
export * from "./KitBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./KitBuilder.vue?vue&type=style&index=0&id=5bc2659a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc2659a",
  null
  
)

export default component.exports